import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export function CodeBlock({ code, testId, className }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      // fallback for insecure contexts
      const ta = document.createElement("textarea");
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Command copied to clipboard");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={cn("relative group rounded-lg border border-slate-800 bg-slate-950 dark:bg-slate-950", className)}>
      <button
        type="button"
        data-testid={testId}
        onClick={copy}
        aria-label="Copy command"
        className="absolute right-2 top-2 z-10 inline-flex items-center gap-1 rounded-md border border-slate-700 bg-slate-800/90 px-2 py-1 text-xs text-slate-200 opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity hover:bg-slate-700"
      >
        {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
        {copied ? "Copied" : "Copy"}
      </button>
      <pre className="tr-scroll overflow-x-auto p-4 pr-16 text-xs sm:text-sm">
        <code className="font-mono text-emerald-400">{code}</code>
      </pre>
    </div>
  );
}
